import { ErrorTypes } from '@wix/form-validator';
import { VatIDType, brazilVatIdValidator, getVatIDType } from './brazil-vat-id-validator';
import { israelVatIdValidator } from './israel-vat-id-validator';
export const validateVatID = _ref => {
  let {
    value,
    target,
    externalData
  } = _ref;
  if (!value) {
    return undefined;
  }
  const country = externalData == null ? void 0 : externalData.country;
  if (country === 'IL') {
    const isValid = israelVatIdValidator(value);
    if (!isValid) {
      return {
        errorPath: target,
        errorType: ErrorTypes.FORMAT_ERROR,
        errorMessage: 'must match format "vat ID"',
        params: {
          format: 'custom IL field validations'
        }
      };
    }
    return undefined;
  }
  const isValid = brazilVatIdValidator(value);
  if (!isValid) {
    return {
      errorPath: target,
      errorType: ErrorTypes.FORMAT_ERROR,
      errorMessage: 'must match format "vat ID"',
      params: {
        format: 'custom BR field validations'
      }
    };
  }
  return undefined;
};
export const getVatIDValue = (id, country) => {
  if (country === 'IL') {
    return {
      id,
      type: VatIDType.UNSPECIFIED
    };
  }
  const vatType = getVatIDType(id);
  return {
    id,
    type: vatType
  };
};
//# sourceMappingURL=vat-id-validation.js.map